<template>
    <div class="section-post-creator">
        <header>
            <div class="container-title">
                <div class="btn-back" @click="$router.push('/dash/planner');"></div>
                <div class="text">
                    <h2 class="title">{{title}}</h2>
                    <p class="switchOldVersion" @click="asignUsers">Assigner des utilisateurs{{ idUsersAssigned.length ? `(${idUsersAssigned.length})` : '' }}</p>
                    <!-- <p v-if="!previewMode.active && mode == 'create'" class="switchOldVersion" @click="switchInterface">Passez à l'ancienne version</p>
                    <p v-else-if="mode !== 'create'" class="switchOldVersion" @click="$router.push('/dash/planner');">Retour au planner</p> -->
                </div>
            </div>

            <div class="btns-action">

                <template v-if="!previewMode.active">
                    <div class="btn-outline-primary" @click="()=>saveDraft()">{{{ create : 'Mise en brouillon',duplicate : 'Mise en brouillon', edit: 'Convertir en brouillon', draft : 'Enregistrer'}[mode || 'create']}}</div>
                    <div class="btn-secondary icon-r" :class="{disable : !pagesValidForPreview.length}" @click="()=>handlerChangePreviewDisplay(true)">{{ textSwitchPreview }}<i class="fa-solid fa-arrow-right"></i></div>
                </template>

                <template v-else>
                    <div class="btn-outline-primary" @click="()=>handlerChangePreviewDisplay(false)">Retour</div>
                    <div class="btn-secondary icon-r" :class="{disable : !pagesValidForPreview.length}">{{textBtnFinish}}<i class="fa-solid fa-arrow-right"></i></div>
                </template>
                
            
            </div>
        </header>
        <div :class="'post-creator '+formShow" ref="postCreator" >
            <div class="container-form" v-if="formShow == 'formMultiple'">
                <div class="nav-type-post">
                    <div class="icon-l" @click.stop="switchTab"><i class="fa-solid fa-pen-to-square"></i>Standard</div>
                    <div v-if="tab == 'story_share'" class="icon-l btn-primary"><i class="fa-solid fa-share-from-square"></i>Partage en story</div>
                    <div v-else class="icon-l" :class="{['btn-primary'] : tab == 'story'}"><i class="fa-solid fa-camera-retro"></i>Story</div>
                </div>

                <div class="container-form-scroll hide-scrollbar">
                    <div class="form">
                        <div class="list-pages-selected hide-scrollbar">
                            <div v-if="tab == 'story' && !pagesSelected.length" class="btn-add-page" @click="openSelectPage">
                                <i class="fa-solid fa-plus"></i>
                                <p>Ajoutez des pages</p>
                            </div>
                            <div v-else class="btn-all-container">
                                <div class="btn-all unselectable-all " :class="{checked: !idPageSelected}" @click="selectPage(null)">
                                    <i class="fa-solid fa-users"></i>
                                    <p>Tous</p>
                                </div> 
                            </div>
                            <div class="container-list-avatars hide-scrollbar">
                                <div class="list-avatars hide-scrollbar">
                                    <Avatar 
                                        v-for="page in (tab == 'story_share' ? pagesInstagramActivedShareStory : pagesSelected)" 
                                        :urlPicture="page.avatar" 
                                        :typeNetwork="page.network" 
                                        :key="page.id"
                                        :checked="page.id == idPageSelected"
                                        :edited="tab == 'story_share' ? saveAllFormData.pages[page.id] && Object.hasOwn(saveAllFormData.pages[page.id], 'storification') : saveAllFormData.pages[page.id] && Object.keys(saveAllFormData.pages[page.id]).length > 0"
                                        @click="()=>selectPage(page)"
                                    />
                                </div>
                            </div>
                        </div>          
                        <FormStory 
                            :formData="formData"
                            :updateFormData="idPageSelected && saveAllFormData.pages[idPageSelected] && saveAllFormData.main.storification[idStorySelected]  ? saveAllFormData.pages[idPageSelected] : {}"
                            :idStorySelected="idStorySelected"
                            :files="files"
                            :tab="tab"
                            @addFile="(...args)=>this.$emit('addFile',...args)"
                            @saveFormData="saveFormData"
                            @restoreFormData="restoreFormData"
                            >
                        </FormStory>
                    </div>
                </div>
            </div>
            
            <div class="container-phone" ref="containerPhone">
                <div :class="`nav-stories left`" v-if="tab !== 'story_share'">
                    <div class="list-stories">
                        <div class="item" v-for="(id, index) in Object.keys(formData.storification).filter(k => (!previewMode.active || !formData.storification[k].hide)).sort()" :class="{active: idStorySelected == id, disable : formData.storification[id].hide}" @click="selectStory(id)">
                            {{index+1}}
                            <Tooltip v-if="!previewMode.active && saveAllFormData.main && saveAllFormData.main.storification && !saveAllFormData.main.storification[id]" :text="'Story propre a la page selectionnée'" position="right" :classCustom="'icon-edited'"></Tooltip>
                        </div>
                        <div class="item" @click="addNewStory" v-if="Object.keys(formData.storification).length < 10 && !previewMode.active">
                            <i class="fa-solid fa-plus"></i>
                        </div>
                    </div>
                </div>

                <!-- switch entre post standard ou parte en story dans la preview -->
                <div class="switch-preview-post-type" v-if="previewMode.active && tab == 'story_share'">
                    <div class="" @click.stop="()=>$emit('changeTab','standard')">Standard</div>
                    <div class="btn-primary">Story</div>
                </div>

                <Phone :firstPlan="phoneIsFirstPlan" :showNotch="false">
                    <StoryMaker
                        :formData="formData"
                        :saveAllFormData="saveAllFormData"
                        :idStorySelected="idStorySelected"
                        :deleteStory="deleteStory"
                        :toggleHideStory="toggleHideStory"
                        :pageSelected="previewMode.active ? previewMode.pageSelected : pagesSelected.find(p => p.id == idPageSelected)"
                        :previewEnabled="previewMode.active"
                        :files="files"
                        @saveFormData="saveFormData"
                    />
                </Phone>
                <template v-if="previewMode.active">
                    <div class="nav-page-standard" v-if="tab == 'story_share'">
                        <div class="list-page hide-scrollbar">
                            <template v-for="(networkName, index) in listNetworkSort">
                                <div class="group" v-if="pagesSelected.some(p => p.network == networkName)" :key="networkName" :class="{'active': false}">
                                    <div class="network" 
                                        :class="{
                                            [networkName]:true, 
                                            edited: saveAllFormData.networks[networkName] && Object.keys(saveAllFormData.networks[networkName]).length > 0,
                                            failed: previewMode.active && pagesSelected.some(page => page.network == networkName && dataFormRequest[page.id] &&  dataFormRequest[page.id].error)
                                        }" 
                                    >
                                    </div>
                                    <div class="list-avatar">
                                       
                                        <div class="container-avatar"
                                            v-for="page in pagesSelected.filter(p => p.network == networkName)" 
                                            :class="{
                                                checked: (previewMode.pageSelected && previewMode.pageSelected.id == page.id), 
                                            }"
                                            :key="page.id"
                                        >
                                          
                                            <Avatar 
                                                @click="()=>{
                                                    $emit('changePreviewDisplay',true, page);
                                                    $emit('generateFormData',page)
                                                }" 
                                                :checkIsPossible="true" 
                                                :checked="(previewMode.pageSelected && previewMode.pageSelected.id == page.id)" 
                                                :urlPicture="page.avatar"

                                            />
                                        </div>
                                    </div>
                                </div>   
                            </template>  
                        </div>
                    </div>

                    <div v-else class="nav-page-story hide-scrollbar">
                        <Avatar 
                            v-for="(page, index) in pagesValidForPreview" 
                            :urlPicture="page.avatar" 
                            :typeNetwork="page.network" 
                            :key="page.id+index" 
                            :checked="previewMode.pageSelected && page.id == previewMode.pageSelected.id"
                            @click="()=>{
                                $emit('changePreviewDisplay',true, page);
                                $emit('generateFormData', page)
                            }" 
                        />
                    </div>    
                </template>
                
            </div>          
        </div>
    </div>
</template>

<script>
import { EventBus } from '@/event-bus';
import store from './../../../store/index.js';
import ComponentSwitch from '../utils/switch.vue';
import Avatar from '../utils/avatar.vue';
import Checkbox from '../utils/checkbox.vue';
import Phone from './Phone.vue';
import FormStory from './FormStory.vue';
import StoryMaker from './StoryMaker.vue';
import selectMention from './formOverlay/selectMention.vue'
import selectHashtag from './formOverlay/selectHashtag.vue'
import Tooltip from './../tooltip/tooltipInit.vue'

import { formDataDefault, maxFilesPerNetwork } from './constante.js'
import SSE from './../../../utils/sse.js'

import postMixin from './../../mixins/Posts.vue'
import draftMixin from './../../mixins/Drafts.vue'


export default {
    components: {
        ComponentSwitch,
        Phone,
        FormStory,
        StoryMaker,
        Avatar,
        Checkbox,
        selectMention,
        selectHashtag,
        Tooltip
    },
    mixins: [postMixin, draftMixin],

    props: {
        mode: String,
        tab: String,
        files:Object,
        formData: Object,
        saveAllFormData: Object,
        dataFormRequest: Object,
        previewMode: Object,
    },

    data() {
        return {
           
            listNetworkSort: ['facebook','instagram','linkedin','google','threads','twitter','tiktok','youtube','pinterest','telegram'],
           

            formShow: "formMultiple",// pour l'annimation
            timeOutAnnimateForm: null,

            idStorySelected: "0",
            idPageSelected: null,
            
        


            //la list mode est connu et modifiable par tout les interfaces Network et les deux formulaires 
            modes : [],
            dataMode : {},


            idUsersAssigned: [],

            dataFormRequest : {},

            showTutorial : !localStorage.postCreatorCountUseSelectorMode ? true : localStorage.postCreatorCountUseSelectorMode < 3,

            pagesInstagramActivedShareStory: []
        }
    },



    created() {
        EventBus.$on('postCreatorAddMode', this.addMode);
        EventBus.$on('postCreatorRemoveMode', this.removeMode);

        if (this.tab == 'story_share') {
            this.setPagesInstagramActivedShareStory()
        }
       
    },

    methods: {
        ///////////// METHOD NAVIGATION /////////////

        switchTab() {
            this.saveFormData()
            this.$emit("generateFormData")
            this.$emit("changeTab",'standard')
   
        },

        selectPage(page = null) {
            if (page) {
                if(!this.idPageSelected)  this.$emit("saveFormData")
                this.idPageSelected = page.id
                this.$emit("generateFormData",page)
            }else{
                this.idPageSelected = null
                this.$emit("generateFormData")
            }

            if (!this.formData.storification[this.idStorySelected] || this.formData.storification[this.idStorySelected].hide) {
                const idsStories = Object.keys(this.formData.storification).sort()
                this.idStorySelected = idsStories.find(id => !this.formData.storification[id].hide) || idsStories[0]
            }
        },

        async handlerChangePreviewDisplay(state) {
            if (state) {
                const page = this.pagesSelected.find(page => page.network == 'instagram' && (!this.idPageSelected || page.id == this.idPageSelected))
                if (page) {
                    this.$emit('changePreviewDisplay', true, page)
                    this.$emit('generateFormData', page)
                }
            }else{
                this.$emit('changePreviewDisplay', false)
                this.selectPage(this.idPageSelected ? this.pagesSelected.find(page => page.id == this.idPageSelected) : null)
            }

        },

        selectStory(id) {
            if (!this.formData.storification[id]) return
            this.idStorySelected = id
        },

        addMode(mode, data = {}) {
            if (!this.modes.includes(mode)) this.modes = [...this.modes,mode]
            this.$set(this.dataMode,mode, data)
        },

        removeMode(mode = 'all') {
            if (mode == 'all') {
                this.modes = []
                return
            }
            this.modes = this.modes.filter(v => v !== mode)
        },

        switchInterface() {
            localStorage.setItem('postCreatorInterfacePreference', 'old')
            this.$router.push({
                name: 'planner',
                params: {
                newPost: true
                }
            })
        },

        openSelectPage() {
            this.$store.commit('selectPage/updateSelectPageListRetracted', false)
        },

        ///////////// METHOD STORY /////////////

        addNewStory() {
            if (this.formData.storification.length >= 10) return
            // const idStory = (Date.now()+(this.formShow == 'formUnique' ? 10000000 : 0)).toString()
            const idStory = Date.now().toString()
            const story = JSON.parse(JSON.stringify(formDataDefault.storification['0']))
            console.log("storyadd",story)
            this.$set(this.formData.storification, idStory,
                story
            )
            this.idStorySelected = idStory
            this.saveFormData()
        },

        deleteStory(id = undefined) {
            if (id === undefined)  id = this.idStorySelected
            const ids = Object.keys(this.formData.storification).sort()
            if(this.formData.storification[id] && ids.length > 1) {
                this.$delete(this.formData.storification, id)
                this.idStorySelected = ids.filter(v => v !== id)[Math.max(0,ids.findIndex(v => v == id)-1)]
            }
            this.saveFormData()
        },

        toggleHideStory(id = undefined) {
            if (id === undefined)  id = this.idStorySelected
            const ids = Object.keys(this.formData.storification).sort()
            const value = !this.formData.storification[id].hide ? true : false
            this.$set(this.formData.storification[id],'hide', value)
            if (value) this.idStorySelected = ids[Math.max(ids.findIndex((k) => !this.formData.storification[k].hide), 0)]
            this.saveFormData()
        },

        //////////// METHOD FOR FORMDATA ////////////

        restoreFormData(path) {     
            console.log("restoreFormData", path, this.idPageSelected, this.saveAllFormData.pages[this.idPageSelected])
            if(this.idPageSelected && this.saveAllFormData.pages[this.idPageSelected]){
                this.$emit("restoreFormData", path, this.pagesSelected.find(page => page.id == this.idPageSelected) || this.allPages.find(page => page.id == this.idPageSelected) )
            }
        },

        saveFormData() {
            this.$emit("saveFormData", this.idPageSelected ? 
                this.pagesSelected.find(page => page.id == this.idPageSelected) || this.allPages.find(page => page.id == this.idPageSelected) 
                : null
            )
        },

        asignUsers() {
            EventBus.$emit('selectUsers',(idUsersSelected)=>{
                console.log('idUsersSelected',idUsersSelected)
                this.idUsersAssigned = idUsersSelected
            },{
                defaultSelection: this.idUsersAssigned
            })
        },

        setPagesInstagramActivedShareStory() {
            console.log("setPagesInstagramActivedShareStory", this.formData.formDataNetwork.instagram.shareInStory)
            let defaultActivedShareStory = this.saveAllFormData.main.formDataNetwork.instagram.shareInStory

            //regarde si la valeur de shareInStory dans la customisation de instagram
            let saveNetworkIsActiveStory = null

            if (
                this.saveAllFormData.networks &&
                this.saveAllFormData.networks['instagram'] && 
                this.saveAllFormData.networks['instagram'].formDataNetwork &&
                this.saveAllFormData.networks['instagram'].formDataNetwork.instagram &&
                this.saveAllFormData.networks['instagram'].formDataNetwork.instagram.hasOwnProperty('shareInStory')
            ) {
                saveNetworkIsActiveStory =  this.saveAllFormData.networks['instagram'].formDataNetwork.instagram.shareInStory
            }
 
            this.pagesInstagramActivedShareStory = this.pagesSelected.filter(page => {
                if (page.network !== 'instagram') return false

                if (this.saveAllFormData.pages[page.id] && 
                    this.saveAllFormData.pages[page.id].formDataNetwork && 
                    this.saveAllFormData.pages[page.id].formDataNetwork.instagram && 
                    this.saveAllFormData.pages[page.id].formDataNetwork.instagram.hasOwnProperty('shareInStory')
                ) {
                    return  this.saveAllFormData.pages[page.id].formDataNetwork.instagram.shareInStory
                }
              
                if (saveNetworkIsActiveStory !== null) {
                    return  saveNetworkIsActiveStory
                }
                return defaultActivedShareStory
            })

        
        },

        saveDraft() {
            this.saveFormData()
            this.$emit('saveDraft')
        },
    },

    computed: {
        allPages() {
            return this.$store.getters['selectPage/selectPageAllPages'];
        },

        pagesSelected() {
            return this.$store.getters['selectPage/selectPagePageSelected'].filter(p => p.network == 'instagram');
        },
       
        phoneIsFirstPlan() {
            let validmodes = ['addCollaboratorMode','addIdentifierMode','addPlaceMode', 'addMusicMode','addMentionMode','addHashtagMode']
            return validmodes.find(v => this.modes.includes(v)) ? true : false
        },

        textContentConverted() {
    
            const regex = /^(<br\s*\/?>|\\n|\s*)+$/i
            if (!this.formData.textContent || regex.test( this.formData.textContent)) return ''
            
            return this.formData.textContent.replaceAll("\\n", '<br>')
        },

        textCommentConverted() {
            const regex = /^(<br\s*\/?>|\\n|\s*)+$/i
            if (!this.formData.textComment || regex.test( this.formData.textComment)) return ''

            return this.formData.textComment ? this.formData.textComment.replaceAll("\\n", '<br>') : ''
        },

        countDataFormRequestValid() {
            return Object.values(this.dataFormRequest).filter(form => !form.hasOwnProperty('error')).length
        },

        textBtnFinish() {
            const forms = Object.values(this.dataFormRequest);
            
            const postPlanified = forms.filter(form => !form.hasOwnProperty('error') && form["data[scheduled_date]"]);
            const postInstantly = forms.filter(form => !form.hasOwnProperty('error') && !form["data[scheduled_date]"]);
            
            if (postPlanified.length && postInstantly.length) {
                return "Publier & planifier";
            } else if (postPlanified.length) {
                return `Planifier sur ${postPlanified.length} page${postPlanified.length > 1 ? 's' : ''}`;
            } else if (postInstantly.length) {
                return `Publier sur ${postInstantly.length} page${postInstantly.length > 1 ? 's' : ''}`;
            }

            return '';
        },

        textSwitchPreview() {
          
            if (this.mode == 'edit') return "Appliquer"
            let postPlanified = false
            let postInstantly = false
            
            const formMain = !this.idPageSelected ? this.formData : this.saveAllFormData.main

            for (let i = 0; i < this.pagesSelected.length; i++) {
                if (postPlanified && postInstantly) break;
                const page = this.pagesSelected[i];

                const formDataByPage = this.idPageSelected  && this.idPageSelected  == page.id ? this.formData : this.saveAllFormData.pages[page.id]
             
    
                if (formDataByPage && formDataByPage.planifiedDate) {
                    if (formDataByPage.planifiedDate.date || formDataByPage.planifiedDate.hours) {
                        postPlanified = true
                    }else {
                        postInstantly = true
                    }
                }else{

                    if (formMain.planifiedDate.date || formMain.planifiedDate.hours) {
                        postPlanified = true
                    } else {
                        postInstantly = true
                    }
                }
            }

            if (postPlanified && postInstantly) {
                return "Publier & planifier";
            } else if (postPlanified) {
                return `Planifier`;
            } else if (postInstantly) {
                return `Publier`;
            }

            return '';
        },

        pagesValidForPreview() {
            return this.pagesSelected.filter(page => {
                if (!this.saveAllFormData.pages[page.id] || !this.saveAllFormData.pages[page.id].storification) return true
                
                const amountNewStory = Object.keys(this.saveAllFormData.pages[page.id].storification).filter(idStory => !this.saveAllFormData.main.storification[idStory]).length
                const amountStoryHide =  Object.values(this.saveAllFormData.pages[page.id].storification).filter(story => story.hide).length
                if (Object.keys(this.saveAllFormData.main.storification).length + amountNewStory > amountStoryHide) return true
                return false
            })
        },

        title () {

            switch (this.mode) {
                case "edit":
                    return "Mode édition"
                case "draft":
                    return "Edition du brouillon"
            
                default:
                    return this.previewMode.active ? 'Prévisualisation' : 'Nouvelle publication'
                   
            }
           
           
        }   
    },

    watch: {

        ["previewMode.active"]: {
            handler(value, oldValue) {
                console.log('watch previewMode.active',value, oldValue)
                if (value) {
                    // if (this.previewMode.pageSelected) this.toggleSelectPageForcustomMode(this.previewMode.pageSelected)
                    if (oldValue == undefined && this.tab == 'story_share') {
                        this.formShow = "preview-right annimate-switch-preview-mode"
                    }else{
                        this.formShow = "preview-right"
                        if (this.timeOutAnnimateForm) clearTimeout(this.timeOutAnnimateForm)
                        this.$nextTick(() => {
                            this.timeOutAnnimateForm = setTimeout(() => {
                                this.$refs.postCreator.classList.add('annimate-switch-preview-mode');
                            }, 500);
                        })
                    }
                }else{
                    this.$refs.postCreator.classList.remove('annimate-switch-preview-mode');
                    if (this.timeOutAnnimateForm) clearTimeout(this.timeOutAnnimateForm)
                    this.$nextTick(() => {
                        this.timeOutAnnimateForm = setTimeout(() => {
                             this.formShow = "formMultiple"
                        }, 1000);
                    })
                }
            },
            immediate: true
        }
    },

    beforeDestroy () {
        EventBus.$off('postCreatorAddMode', this.addMode);
        EventBus.$off('postCreatorRemoveMode', this.removeMode);
        EventBus.$off('deletePostFromClickSelectPage', this.deletePostFromClickSelectPage);
    }

}
</script>
